import { TypedDocumentNode, gql } from '@apollo/client';
import { useMemo } from 'react';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useLeaderboardGroupHasAScoutingPage_so5LeaderboardGroupInterface } from './__generated__/useLeaderboardGroupHasAScoutingPage.graphql';

type Props = {
  so5LeaderboardGroup?: useLeaderboardGroupHasAScoutingPage_so5LeaderboardGroupInterface;
};

export const useLeaderboardGroupHasAScoutingPage = ({
  so5LeaderboardGroup,
}: Props) => {
  const { sport = Sport.FOOTBALL } = useSportContext();
  const {
    so5: { competitionEligibilityAlgoliaFilters },
  } = useConfigContext();

  const authorizedLeaderboardGroups = Object.keys(
    competitionEligibilityAlgoliaFilters
  );
  const algoliaFilterKey = authorizedLeaderboardGroups.find(
    k => k === so5LeaderboardGroup?.displayName
  );

  const leaderboardGroupHasAScoutingPage = useMemo(() => {
    switch (sport) {
      case Sport.FOOTBALL:
        return !!algoliaFilterKey;
      case Sport.BASEBALL:
        return false;
      case Sport.NBA:
      default:
        return true;
    }
  }, [algoliaFilterKey, sport]);

  return {
    leaderboardGroupHasAScoutingPage,
    algoliaFilterKey,
  };
};

useLeaderboardGroupHasAScoutingPage.fragments = {
  so5LeaderboardGroup: gql`
    fragment useLeaderboardGroupHasAScoutingPage_so5LeaderboardGroupInterface on So5LeaderboardGroupInterface {
      slug
      displayName
    }
  ` as TypedDocumentNode<useLeaderboardGroupHasAScoutingPage_so5LeaderboardGroupInterface>,
};
